import React from "react";
import ReactDOM from "react-dom/client";
import cn from "classnames";
import {createStore, withStore} from "game_play/utils/store";
import Games from "game/modal/games";
import EmptyState from "championship/src/components/EmptyState/emptyState";
import Dropdown from "championship/src/components/Dropdown";
import {ReactComponent as MoreVertical} from 'championship/static/championship/icon/feather/more-vertical.svg'
import {ReactComponent as Play} from 'championship/static/championship/icon/feather/play.svg'
import {ReactComponent as Tv} from 'championship/static/championship/icon/feather/tv.svg'
import {ReactComponent as Crosshair} from 'championship/static/championship/icon/feather/crosshair.svg'
import {ReactComponent as Edit} from 'championship/static/championship/icon/feather/edit.svg'
import { atom, createCtx } from "@reatom/core";
import { GameFormEdit } from "./game-form-edit";
import { reatomContext } from "@reatom/npm-react";
import { Modal } from "championship/src/components/Modal";


const modal_form_atom_game_edit = atom(false)

const ctx = createCtx()

class TableGames extends React.Component {
  state = {
    visible: false,

    picked_game:  null,
  }

  unsubscribeSocket = null

  fetchGames() {
    const {Games} = this.props

    Games.fetch()
    // this.unsubscribeSocket = Games.subscribe()
  }

  componentDidMount() {
    this.fetchGames()
    this.initExternalTriggers()
  }

  initExternalTriggers(){
    for(const dom of document.querySelectorAll('.js-trigger-edit-view')){
      dom.addEventListener('click', function(){
        const {Games} = this.props
        const games = Games.get('games')
        const id = dom.getAttribute('data-game-id')
        const game = games.find(item => item.id == id)
        this.handlerOpenEditMatch(game)
      }.bind(this))
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  componentWillUnmount() {
    if (this.unsubscribeSocket) {
      this.unsubscribeSocket()
    }
  }

  handlerToggleVisible = () => {
    this.setState({
      visible: !this.state.visible
    })
  }

  handlerOpenEditMatch = (game) => {
    // console.log('handlerOpenEditMatch', game)
    this.setState({
      picked_game: game,
    })
    modal_form_atom_game_edit(ctx, true)
  }

  renderRow(game, i) {
    const {Games} = this.props
    return (
      <tr key={game.id}>
        <td>{i + 1}</td>
        <td>{Games.formatTime(game.date)}</td>
        <td><a href={game.absolute_url}>{game.player_vs_player}</a></td>
        <td>{game.stage_display}</td>
        <td>{game.score}</td>
        {/*<td></td>*/}
        <td className={cn({
          hide: !game.live_url
        })}>
          <Dropdown
            trigger={() => <MoreVertical
              className='tournament-row__dropdown text-hover hit-area-8'
            />}
            offset={8}
          >
            <Dropdown.Option href={game.live_url} target='_blank' icon={<Play/>}>
              {gettext('Начать матч')}
            </Dropdown.Option>
            <Dropdown.Option href={game.score_tv_url} target='_blank' icon={<Tv/>}>
              {gettext('ТВ-экран')}
            </Dropdown.Option>
            <Dropdown.Option href={game.score_panel_url} target='_blank' icon={<Crosshair/>}>
              {gettext('ТВ-счет')}
            </Dropdown.Option>
            {/* <Dropdown.Option href={game.edit_url} icon={<Edit/>}>
              {gettext('Редактировать матч')}
            </Dropdown.Option> */}
            <Dropdown.Option onClick={() => {this.handlerOpenEditMatch(game)}} icon={<Edit/>}>
              {gettext('Редактировать матч')}
            </Dropdown.Option>
          </Dropdown>
        </td>
      </tr>
    )
  }

  render() {
    const {Games} = this.props
    const {visible} = this.state;
    const games = Games.get('games')
    const gamesFilter = visible ? games : games.slice(0, 10);

    return (
      <div className='table-wrap'>
        <table className='table'>
          <thead>
          <tr>
            <th>№</th>
            <th>{gettext('Время')}</th>
            <th>{gettext('Пара')}</th>
            <th>{gettext('Стадия')}</th>
            <th>{gettext('Лэги')}</th>
            {/*<th>{gettext('Счет')}</th>*/}
            {/*<th></th>*/}
          </tr>
          </thead>
          <tbody>
          {Games.get('status') === 'loading' ? (
            <tr>
              <td colSpan='7'>
                <div className="loader-ui">
                  <div/>
                  <div/>
                  <div/>
                  <div/>
                  <div/>
                </div>
              </td>
            </tr>
          ) : !games.length && (
            <tr>
              <td colSpan='7'>
                <EmptyState text={gettext('Матчей нету')}/>
              </td>
            </tr>
          )}
          {gamesFilter.map((game, i) => this.renderRow(game, i))}
          </tbody>
        </table>
        {
          games.length > 10 && (
            <button className="button -link" style={{width: '100%', height: '44px'}} onClick={this.handlerToggleVisible}>
              {visible ? gettext('Скрыть') : gettext('Смотреть все')}
            </button>
          )
        }
        <reatomContext.Provider value={ctx}>
          <>
            <Modal 
              _atom={modal_form_atom_game_edit}
              label={`Завершить ${
                this.state.picked_game?.player_vs_player
                  ?.replace(/[_\s\-]/g, '')?
                this.state.picked_game?.player_vs_player : 'матч'
              }?`}
              caption="Что бы завершить матч, выберите победителя:"
            >
              <GameFormEdit
                trigger_atom={modal_form_atom_game_edit}
                game={this.state.picked_game}
                />
            </Modal>
          </>
        </reatomContext.Provider>
      </div>
    )
  }
}

const TableGamesWithStore = createStore(withStore(TableGames), {
  Games
}, {
  games: window.INIT_DATA || []
})

const root = ReactDOM.createRoot(document.getElementById('table-games'));
root.render(
  <TableGamesWithStore/>
);